import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from '@lib/helmet-shim';

/**
 * WGPlayer Advertisement Component
 * 
 * Loads WGPlayer advertisement script and handles SPA navigation.
 * - Adds dns-prefetch for performance optimization
 * - Reloads ad script on every route change to fix SPA issues
 * 
 * @component
 */
const WGPlayerAd: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Load WGPlayer ad script
    const loadWGPlayerScript = () => {
      // Remove existing script if any to ensure fresh load
      const existingScript = document.querySelector('script[src*="universal.wgplayer.com/tag"]');
      if (existingScript) {
        existingScript.remove();
      }

      // Create and inject new script
      const script = document.createElement('script');
      const firstScript = document.getElementsByTagName('script')[0];
      
      script.async = true;
      script.src = `https://universal.wgplayer.com/tag/?lh=${window.location.hostname}&wp=${window.location.pathname}&ws=${window.location.search}`;
      script.setAttribute('fetchpriority', 'high');
      
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      }
    };

    // Load script on mount and route changes
    loadWGPlayerScript();

    // Cleanup function
    return () => {
      const script = document.querySelector('script[src*="universal.wgplayer.com/tag"]');
      if (script) {
        script.remove();
      }
    };
  }, [location.pathname, location.search]); // Reload when route changes

  return (
    <Helmet>
      <link rel="dns-prefetch" href="https://universal.wgplayer.com" />
    </Helmet>
  );
};

export default WGPlayerAd;
